import getArrayIndex from './utils/get-array-index';
import getKey from './utils/get-key';
import shallowCopy from './utils/shallow-copy';
const parseKey = (path, value) => {
    const [key, remainingPath] = getKey(path);
    const hasArrayNotation = getArrayIndex(key);
    const compiledValue = (remainingPath ? parseKey(remainingPath, value) : shallowCopy(value));
    return (hasArrayNotation ? [compiledValue] : { [key]: compiledValue });
};
export default parseKey;
//# sourceMappingURL=parse-key.js.map